export enum CatalogMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_FAVORITES_LOADING = 'SET_FAVORITES_LOADING',
  SET_CATEGORIES = 'SET_CATEGORIES',
  SET_PRODUCTS = 'SET_PRODUCTS',
  SET_SPECIAL_OFFER = 'SET_SPECIAL_OFFER',
  SET_QUICK_ORDERS = 'SET_QUICK_ORDERS',
  SET_PRODUCTS_INFO = 'SET_PRODUCTS_INFO',
  SET_QUICK_ORDERS_INFO = 'SET_QUICK_ORDERS_INFO',
  SET_SPECIAL_OFFER_INFO = 'SET_SPECIAL_OFFER_INFO',
  RESET_PRODUCTS_PAGE = 'RESET_PRODUCTS_PAGE',
  SET_FILTERS = 'SET_FILTERS',
  SET_FAVORITES = 'SET_FAVORITES',
  SET_FAVORITES_INFO = 'SET_FAVORITES_INFO',
  SET_PRODUCT = 'SET_PRODUCT',
  SET_PACKAGING = 'SET_PACKAGING',
  SET_WISHLIST = 'SET_WISHLIST',
  SET_ALIGNMENT = 'SET_ALIGNMENT',
  SET_QUERIES = 'SET_QUERIES',
  SET_ERROR = 'SET_ERROR',
  SET_SHIP_TO = 'SET_SHIP_TO',
  SET_PRODUCT_WISHLIST = 'SET_PRODUCT_WISHLIST',
  SET_PRODUCT_WISHLIST_INFO = 'SET_PRODUCT_WISHLIST_INFO',
  SET_RECOMMENDED_INFO = 'SET_RECOMMENDED_INFO',
  SET_RECOMMENDED = 'SET_RECOMMENDED',
  SET_RECOMMENDED_ITEMS = 'SET_RECOMMENDED_ITEMS',
  SET_ADD_TO_FULL_ORDER = 'SET_ADD_TO_FULL_ORDER',
  SET_SHIP_TO_METHOD = 'SET_SHIP_TO_METHOD',
  SET_PAYMENT_METHOD= 'SET_PAYMENT_METHOD',
  SET_CATALOGUE_SORT = 'SET_CATALOGUE_SORT',
  SET_QUICK_ORDER_SORT = 'SET_QUICK_ORDER_SORT',
  SET_FAVOURITE_SORT = 'SET_FAVOURITE_SORT',
  SET_LOW_STOCK_PRODUCT= 'SET_LOW_STOCK_PRODUCT',
  SET_SHOW_LOW_STOCK_PRODUCT= 'SET_SHOW_LOW_STOCK_PRODUCT',
  SET_FREE_BEER_PRODUCT= 'SET_FREE_BEER_PRODUCT',
  SET_ADD_FREE_BEER_PRODUCT= 'SET_ADD_FREE_BEER_PRODUCT',
  SET_FREEBEERS_INFO = 'SET_FREEBEERS_INFO',
  SET_FREEBEERS_RUNNING = 'SET_FREEBEERS_RUNNING',
  SET_FAVORITES_FILTERS = 'SET_FAVORITES_FILTERS',
  SET_SHIP_TO_ADDRESS = 'SET_SHIP_TO_ADDRESS',
  SET_CATEGORIES_FILTER = 'SET_CATEGORIES_FILTER',
  SET_SHIP_TO_ID = 'SET_SHIP_TO_ID',
  SET_TOTAL_COUNT = 'SET_TOTAL_COUNT',
  SET_SPECIAL_OFFER_TOTAL_COUNT = 'SET_SPECIAL_OFFER_TOTAL_COUNT',
  SET_QUICK_ORDERS_TOTAL_COUNT = 'SET_QUICK_ORDERS_TOTAL_COUNT'
}
